
/**
 * Utility functions for workplace requests
 */

export const getStatusIcon = (status: string) => {
  switch (status) {
    case 'open':
      return 'circle-gray';
    case 'pending':
      return 'diamond-orange';
    case 'closed':
      return 'circle-green';
    default:
      return 'circle-gray';
  }
};

export const getStatusColor = (status: string) => {
  switch (status) {
    case 'Open':
      return 'text-gray-600';
    case 'Pending':
      return 'text-orange-600';
    case 'Closed':
      return 'text-green-600';
    default:
      return 'text-gray-600';
  }
};

export const getCityFromLocation = (location: string) => {
  return location.split(' - ')[0];
};

export const getInitials = (name: string) => {
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase();
};




